import React from 'react'
import cn from 'classnames'
import { WbImage } from '@workbench/react/dist'
import { Booking as BookingT } from 'api/types'
import { CancelBookingButton } from './CancelBookingButton'
import { EditBookingButton } from './EditBookingButton'
import {
  formatDate,
  formatDateTime,
  formatKilometers,
  formatPrice,
} from 'utils/format'
import classes from './Booking.module.scss'
import { useVehicle } from 'api'
import { vehicleImage } from 'utils/vehicleImage'
import { bookingDurationInDays } from 'utils/bookingDateUtils'
import { Station, VehicleCount } from 'components'
import { useTranslation } from 'react-i18next'

const formatTarif = (booking: BookingT) => {
  const days = bookingDurationInDays(booking.startDate, booking.endDate)

  if (days >= 30) {
    return 'pages.bookings.bookingsPage.booking.tarifs.monthly'
  } else if (days >= 7) {
    return 'pages.bookings.bookingsPage.booking.tarifs.weekly'
  } else {
    return 'pages.bookings.bookingsPage.booking.tarifs.daily'
  }
}

interface BookingProps {
  booking: BookingT
}

export const Booking: React.FunctionComponent<BookingProps> = ({ booking }) => {
  const { data: vehicle } = useVehicle(booking.vehicleId)
  const { t } = useTranslation()
  const days = bookingDurationInDays(booking.startDate, booking.endDate)
  return (
    <div className={classes.booking}>
      <table className={cn('wb-table', classes.bookingItem)}>
        <tbody>
          <tr>
            <th scope="row">
              {t('pages.bookings.bookingsPage.booking.createdOn')}
            </th>
            <td>{formatDate(booking.createdAt)}</td>
          </tr>
          <tr>
            <th scope="row">
              {t('pages.bookings.bookingsPage.booking.startDateTime')}
            </th>
            <td>{formatDateTime(booking.startDate)}</td>
          </tr>
          <tr>
            <th scope="row">
              {t('pages.bookings.bookingsPage.booking.endDateTime')}
            </th>
            <td>{formatDateTime(booking.endDate)}</td>
          </tr>
          <tr>
            <th scope="row">
              {t('pages.bookings.bookingsPage.booking.pickUpStation')}
            </th>
            <td>
              <Station stationId={booking.pickUpStationId} />
            </td>
          </tr>
          <tr>
            <th scope="row">
              {t('pages.bookings.bookingsPage.booking.vehicle')}
            </th>
            <td>
              <VehicleCount
                count={booking.vehicleCount}
                vehicleGroup={vehicle?.group}
              />
            </td>
          </tr>
          <tr>
            <th scope="row"></th>
            <td></td>
          </tr>
          <tr className={classes.sectionRow}>
            <th scope="row">
              {t('pages.bookings.bookingsPage.booking.yourTarif')}
            </th>
            <td></td>
          </tr>
          <tr>
            <th scope="row">
              {t('pages.bookings.bookingsPage.booking.tarif')}
            </th>
            <td>{t(formatTarif(booking))}</td>
          </tr>
          <tr>
            <th scope="row">
              {t('pages.bookings.bookingsPage.booking.freeKilometers')}
            </th>
            <td>{formatKilometers(booking.includedKilometers / days)}</td>
          </tr>
          {/*
          <tr>
            <th scope="row">Selbsbehalt</th>
            <td>{formatPrice(1000)}</td>
          </tr>
          */}
          <tr>
            <th scope="row">
              {t('pages.bookings.bookingsPage.booking.expectedPrice')}
            </th>
            <td>{formatPrice(booking.priceTotal)}</td>
          </tr>
        </tbody>
      </table>

      <div className={classes.aside}>
        <WbImage
          ratio="3x2"
          src={vehicle ? vehicleImage(vehicle.group) : undefined}
          alt={vehicle?.group}
        />

        <div className={classes.actions}>
          <EditBookingButton booking={booking} />
          <CancelBookingButton booking={booking} />
        </div>
      </div>
    </div>
  )
}
